module.exports = __webpack_public_path__ + "front/img/slogan01.a601a01e.png";